<div class="amg-countdown">
  <div *ngIf="title"
       class="amg-countdown__title">{{title}}</div>
  <div #countDownRef
       class="amg-countdown__content"></div>
</div>
